package com.essntl.features.currency.ui.addcurrency

import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.currency.domain.repository.CurrencyRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AddCurrencyViewModel(
    private val currencyRepository: CurrencyRepository,
    private val configurationRepository: ConfigurationRepository,
    private val state: MutableStateFlow<AddCurrencyState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AddCurrencyEvent) {
        when (event) {
            is AddCurrencyEvent.GetAllCurrencies -> getAllCurrencies()
            is AddCurrencyEvent.SetConfigurationCurrency -> setConfigurationCurrency(event)
            is AddCurrencyEvent.SelectUnselectCurrency -> selectUnselectCurrency(event)
            is AddCurrencyEvent.AddCurrencies -> addCurrencies()
            is AddCurrencyEvent.ClearState -> clearState()
        }
    }

    private fun getAllCurrencies() =
        getData(
            getData = { currencyRepository.getAll() },
            getState = { state.value.getAllCurrencies },
            setState = { newState -> state.update { it.copy(getAllCurrencies = newState) } },
        )

    private fun setConfigurationCurrency(event: AddCurrencyEvent.SetConfigurationCurrency) {
        state.value.configurationCurrency.value = event.configurationCurrency

        state.update {
            it.copy(
                selectedCurrenciesCode = event.configurationCurrency.allowed.map { code -> code },
            )
        }
    }

    private fun selectUnselectCurrency(event: AddCurrencyEvent.SelectUnselectCurrency) =
        state.update {
            it.copy(
                selectedCurrenciesCode =
                if (event.currencyCode in it.selectedCurrenciesCode)
                    it.selectedCurrenciesCode - event.currencyCode
                else
                    it.selectedCurrenciesCode + event.currencyCode,
            )
        }

    private fun addCurrencies() {
        val configurationCurrency = state.value.configurationCurrency.value ?: return

        getData(
            getData = {
                configurationRepository.updateAllowedCurrencies(
                    configurationCurrency.copy(
                        allowed = state.value.selectedCurrenciesCode.toList(),
                    ),
                )
            },
            getState = { state.value.addCurrency },
            setState = { newState -> state.update { it.copy(addCurrency = newState) } },
        )
    }

    private fun clearState() {
        state.value = AddCurrencyState()
    }
}